import { render } from "./Archived.vue?vue&type=template&id=7ceaebea&scoped=true"
import script from "./Archived.vue?vue&type=script&lang=js"
export * from "./Archived.vue?vue&type=script&lang=js"

import "./Archived.vue?vue&type=style&index=0&id=7ceaebea&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ceaebea"]])

export default __exports__